import { render, staticRenderFns } from "./EditAppointTabContent.vue?vue&type=template&id=038bdd5b&scoped=true&"
import script from "./EditAppointTabContent.vue?vue&type=script&lang=js&"
export * from "./EditAppointTabContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038bdd5b",
  null
  
)

export default component.exports